import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'ui-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input() selected = false;
  @HostBinding('class.card-selected') get cardSelected() {
    return this.selected;
  }
}
